import type { TParams } from './types.ts';

/**
 * Render a template with `{name}` placeholders against a params object.
 *
 * Rules
 * - Unknown placeholders stay literal (`{foo}`) — surfaces missing data
 *   loudly in the UI instead of eating copy.
 * - Unused params are silently ignored.
 * - No escape sequences. Double braces are NOT honoured: `{{name}}`
 *   with `{ name: 'x' }` renders `{x}`. Dictionary authors must avoid
 *   literal braces in templates.
 */
const PLACEHOLDER_PATTERN = /\{(\w+)\}/g;

export function substitute(template: string, params: TParams | undefined): string {
  if (params === undefined) {
    return template;
  }
  return template.replace(PLACEHOLDER_PATTERN, (match, rawKey: string) => {
    const value = params[rawKey];
    if (value === undefined) {
      return match;
    }
    return String(value);
  });
}
